import React, {useState} from "react";
import {motion, AnimatePresence} from "framer-motion";
import AppSettingController from "../../../Main/controller/AppSettingController";
import MarketRepository from "../../../Main/repository/MarketRepository";
import Toast from "../../../../utility/toast";
import ServiceCaller from "../../../../services/ServiceCaller";
import {useParams} from "react-router-dom";
import toast from "react-hot-toast";
import {useTranslation} from "react-i18next";

export default function BaseUrl() {
    const {t} = useTranslation();
    const [state, setState] = useState("");
    const setting = MarketRepository.getSettingMarket();
    const {shopId} = useParams();
    const serviceCaller = new ServiceCaller();

    const saveBaseUrl = () => {
        const url = state.trim();

        const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9.-]+|\d{1,3}(\.\d{1,3}){3})(:\d+)?(\/.*)?$/i;

        if (!urlRegex.test(url)) {
            Toast.error(t("setting.error.addressInvalid"));
            return;
        }

        AppSettingController.setbaseUrl(url);
        Toast.success(t("setting.success.addressSubmit"));
    };

    const testServer = async () => {
        const response = await serviceCaller.testBaseUrl(shopId as string)

        if (response)
            return toast.success(t("setting.success.serverAvailable"))
        return toast.error(t("setting.error.serverNotAvailable"))
    }

    return (
        <AnimatePresence>
            {setting?.service !== "netbee" && (
                <motion.section
                    className="public-key-container"
                    initial={{scaleY: 0, opacity: 0}}
                    animate={{scaleY: 1, opacity: 1}}
                    exit={{scaleY: 0, opacity: 0}}
                    transition={{duration: 0.3, ease: "easeInOut"}}
                    style={{originY: 0}}
                >
                    <p>{t("setting.baseUrl")}</p>
                    <div className={`public-key ${setting.service === 'hami' ? 'public-key-with-description' : ''}`}>
                        <div className={'input-with-description'}>
                            <input
                                defaultValue={setting.baseUrl}
                                onChange={(e) => setState(e.target.value)}
                            />
                            {setting.service === 'hami' ? <p>{t("setting.baseUrlPngWarning")}</p> : undefined}
                        </div>
                        {setting.service === 'localServer' ? <button onClick={testServer}>
                            {t("test")}
                        </button> : null}
                        <button type="button" onClick={saveBaseUrl}>
                            {t("submit")}
                        </button>
                    </div>
                </motion.section>
            )}
        </AnimatePresence>
    );
}
